var amdi18n={"__root":{"SEND":"Send","HOW_CAN_WE_DO_BETTER":"How can we do better?","WE_ARE_A_SMALL_TEAM":"We're a small team working extremely hard to bring you the best possible experience.","FEEDBACK_PLACEHOLDER_TEXT":"Enter your feedback here"},"__fr":{"SEND":"Envoyez","HOW_CAN_WE_DO_BETTER":"Que pouvons-nous améliorer?","WE_ARE_A_SMALL_TEAM":"Nous sommes une petite équipe qui travaille extrêmement dur pour vous apporter la meilleure expérience possible.","FEEDBACK_PLACEHOLDER_TEXT":"Entrez vos commentaires ici"},"__en":{"SEND":"Send","HOW_CAN_WE_DO_BETTER":"How can we do better?","WE_ARE_A_SMALL_TEAM":"We're a small team working extremely hard to bring you the best possible experience.","FEEDBACK_PLACEHOLDER_TEXT":"Enter your feedback here"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;